import { arrayWithLength } from '~src/util';

import { Dot, DotContainer } from '../style';
import { PaginationProps } from '../types';

export const Pagination = ({ total, current, style, type }: PaginationProps) => (
  <DotContainer {...{ style }}>
    {arrayWithLength(total, value => value).map(dot => (
      <Dot key={dot} active={dot === current} type={type} />
    ))}
  </DotContainer>
);
